import { createContext, useContext } from 'react';

import { type TSpotlightAPI } from './types';

export const SpotlightAPIContext = createContext<TSpotlightAPI | null>(null);

/** Read the Spotlight API. Throws if used outside `<SpotlightProvider>`. */
export function useSpotlightAPI(): TSpotlightAPI {
  const api = useContext(SpotlightAPIContext);
  if (!api) {
    throw new Error('useSpotlightAPI must be used within <SpotlightProvider>');
  }
  return api;
}
